import React from 'react';
import styled from 'styled-components';
import { minBp, maxBp } from 'src/lib/theme';

export const Outer = styled.div`
  ${({ horizontalScroll, packs, showResults, resultCount, isAccessoryCard }) => `
    ${
      horizontalScroll
        ? `
      height: ${isAccessoryCard ? '213px' : '167px'};
      padding-top: ${packs || (showResults && !resultCount) ? 0 : '15px'};
      position: relative;
      width: calc(100% + 30px);

      @media ${minBp('tabletLarge')} {
        width: calc(100% + 40px);
      }

      ${
        packs
          ? `
        height: 253px;

        @media ${minBp('tabletLarge')} {
          height: 314px;
        }
      `
          : ``
      }
    `
        : ``
    }
    
    @media ${minBp('desktop')} {
      width: calc(100% + 40px);
      flex: 1;
    }

    .ScrollbarsCustom {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .ScrollbarsCustom-Wrapper {
      position: relative;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;

      ${
        !horizontalScroll
          ? `
        @media ${maxBp('desktop')} {
          overflow: inherit !important;
          position: relative !important;
        }
      `
          : ``
      }

      @media ${minBp('desktop')} {
        right: 10px;
        overflow: hidden;
      }
    }

    .ScrollbarsCustom-Scroller {
      position: relative;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;

      ${
        !horizontalScroll
          ? `
        @media ${maxBp('desktop')} {
          position: relative !important;
          overflow: inherit !important;
        }
      `
          : ``
      }

      @media ${minBp('desktop')} {
        margin-right: ${packs ? 0 : '-15px'};
        overflow: hidden scroll;
      }
    }

    .ScrollbarsCustom-Content {
      box-sizing: border-box;
      padding: 0.05px;
      min-height: 100%;
      min-width: 100%;
    }

    .ScrollbarsCustom-TrackY {
      position: absolute;
      overflow: hidden;
      border-radius: 4px;
      user-select: none;
      width: 10px;
      right: 0px;
      top: 0;
      height: calc(100% - 40px);
      background: #d0cfd0;
    }

    .ScrollbarsCustom-ThumbY {
      touch-action: none;
      cursor: pointer;
      border-radius: 4px;
      width: 100%;
      height: 385.054px;
      transform: translateY(0px);
      background-color: #585a5f;
    }

    .ScrollbarsCustom-Track.ScrollbarsCustom-TrackX {
      position: absolute;
      overflow: hidden;
      border-radius: 0px;
      background: #dddddd;
      user-select: none;
      height: 1px;
      top: -15px;
      left: 0px;
      width: calc(100% - 30px);
    }
  
    .ScrollbarsCustom-Thumb.ScrollbarsCustom-ThumbX {
      touch-action: none;
      cursor: pointer;
      border-radius: 0px;
      background: #000;
      height: 100%;
      width: 1245.69px;
      transform: translateX(0px);
    }
  `}
`;

export const Wrap = styled.div`
  ${({ horizontalScroll, cardCount, packs, isAccessoryCard }) => `
    display: ${packs ? 'block' : 'grid'};
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;

    @media ${minBp('tablet')} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 16px;
    }

    @media ${minBp('tabletLarge')} {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }

    @media ${minBp('desktop')} {
      grid-template-columns: 155px 155px;
      padding-bottom: 40px;

      ${
        packs
          ? `
        padding-right: 30px;
      `
          : ``
      }
    }

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      display: flex;
      flex-wrap: wrap;
    }

    ${
      horizontalScroll
        ? `
      @media ${maxBp('desktop')} {
        display: grid;
        grid-gap: 8px;
        grid-auto-flow: column;
        grid-auto-columns: 126px;
        -ms-grid-columns: (126px)[${cardCount}];
        grid-auto-rows: ${isAccessoryCard ? '198px' : '152px'};
        grid-template-columns: none;

        @media ${minBp('tablet')} {
          grid-gap: 12px;
        }

        ${
          packs
            ? `
          grid-auto-columns: 260px;
          grid-auto-rows: ${isAccessoryCard ? '268px' : '238px'};

          @media ${minBp('tabletLarge')} {
            grid-auto-rows: ${isAccessoryCard ? '344px' : '314px'};
          }
        `
            : ``
        }
      }
    `
        : ``
    }
  `}
`;

export const Gutter = styled.div`
  ${({ horizontalScroll, packs }) => `    
    ${
      horizontalScroll
        ? `
        width: 22px;
        height: 1px;
    `
        : `
        display: none;
        `
    }

    @media ${minBp('desktop')} {
      ${
        packs
          ? `
        display: block;
        margin-bottom: -20px;
      `
          : ``
      }
    }
  `}
`;

export const ResultCount = styled.div`
  ${({ resultCount }) => `  
    font-family: ${({ theme }) => theme.fonts.dinRegular};
    font-size: 14px;
    color: #000000;
    margin-bottom: 14px;
    display: ${!resultCount ? 'block' : 'none'};

    span {
      font-family: ${({ theme }) => theme.fonts.dinDemi};
    }

    @media ${minBp('desktop')} {
      display: block;
    }
  `}
`;
